<template>
  <footer>
    <div class="follows">FOLLOW US</div>
    <div class="content">
      <div class="iconBox">
        <span v-for="item in iconList" :key="item.id" :class="item.id == 4 && !isMobile ? 'hidden_weixin': ''">
          <span v-if="item.id == 4" @click="nativeShareCall">
            <img :src="item.imgUrl" alt="" />
          </span>
          <a :href="item.href" v-else>
            <img :src="item.imgUrl" alt="" />
          </a>
        </span>
      </div>
    </div>
    <div v-if="!isMobile" class="pageTop" @click="pageTop">
      <div class="imgBox">
        <img :src="require('@/assets/img/website/top.png')" alt="" />
      </div>
      <div class="text">PAGE TOP</div>
    </div>
    <div v-else class="mbTop" @click="pageTop">
      <img :src="require('@/assets/img/website/mb-top.png')" alt="" />
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    isMobile: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      iconList: [
        {
          id: 1,
          imgUrl: require("@/assets/img/website/twitter.png"),
          href: "https://twitter.com/honeyee_com",
        },
        {
          id: 2,
          imgUrl: require("@/assets/img/website/Facebook.png"),
          href: "https://www.facebook.com/honeyeecom",
        },
        {
          id: 3,
          imgUrl: require("@/assets/img/website/ins.png"),
          href: "https://www.instagram.com/honeyee.com_webmagazine/",
        },
        {
          id: 4,
          imgUrl: require("@/assets/img/website/weixin.png"),
          href: "",
        },
        {
          id: 5,
          imgUrl: require("@/assets/img/website/weibo.png"),
          href: "",
        },
      ],
    };
  },
  methods: {
    pageTop() {
      this.$emit("pageTop");
    },
    nativeShareCall() {
      this.$emit('nativeShareCall')
    }
  },
};
</script>
<style lang="scss" scoped>
footer {
  width: 100%;
  height: auto;
  margin-top: 80px;
  padding-bottom: 80px;
  border-top: 1px solid #e5e5e5;
  position: relative;

  .follows {
    width: 100%;
    text-align: center;
    margin: 70px 0 20px 0;
    font-family: Helvetica;
    font-size: 22px;
    line-height: 29px;
    color: #232323;
  }
  .content {
    width: 100%;
    text-align: center;
    .iconBox {
      width: 190px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      span {
        cursor:pointer;
        width: 26px;
        height: 26px;
        img {
          width: 100%;
        }
      }
    }
  }
  .pageTop {
    position: absolute;
    top: 87px;
    right: 60px;
    text-align: center;
    .imgBox {
      height: 20px;
      margin-bottom: 10px;
      display: inline-block;
      img {
        height: 20px;
      }
    }
    .text {
      font-family: Helvetica;
      font-weight: bold;
      font-size: 16px;
      line-height: 18px;
      color: #232323;
    }
  }
  .mbTop {
    position: absolute;
    left: 20 * $px;
    top: 50 * $px;
    height: 115 * $px;
    width: 22 * $px;
    img {
      height: 90 * $px;
    }
  }
}

.hidden_weixin {
  display: none;
  width: 0px;
  //visibility:hidden;
  //opacity:0;
  //position: absolute;
  //top: -999999999;
}
</style>



// WEBPACK FOOTER //
// footer.vue